export function setMaskCep(value: string): string {
    value = value.replace(/\D/g, "");
    value = value.replace(/^(\d{5})(\d)/, "$1-$2");
    return value;
}

export function setMaskCpf(value: string): string {

    if (!value.match(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})$/)) {
        value = value.replace(/\D/g, "");
        value = value.replace(/(\d{3})(\d)/, "$1.$2");
        value = value.replace(/(\d{3})(\d)/, "$1.$2");
        value = value.replace(/(\d{3})(\d{2})$/, "$1-$2");
    }
    return value;

}


export const setMaskCnpj = (value: string): string => {
    // Já está com máscara completa alfanumérica: XX.XXX.XXX/XXXX-XX
    if (/^[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-[0-9]{2}$/.test(value)) {
        return value;
    }
    // Remove apenas os separadores da máscara, preservando letras
    let v = value.toUpperCase().replace(/[.\-/\s]/g, '').replace(/[^A-Z0-9]/g, '');
    if (v.length > 2) { v = v.substring(0, 2) + '.' + v.substring(2); }
    if (v.length > 6) { v = v.substring(0, 6) + '.' + v.substring(6); }
    if (v.length > 10) { v = v.substring(0, 10) + '/' + v.substring(10); }
    if (v.length > 15) { v = v.substring(0, 15) + '-' + v.substring(15); }
    return v;
}

export const setMaskExpirationDateCreditCard = (value: string): string => {
    value = value.replace(/\D/g, "");

    if (value.length > 2) {
        value = value.substring(0, 2) + "/" + value.substring(2);
    }
    return value;
}
